(ns motorsaif.web.pages.home
  (:require
   [re-frame.core :as rf :refer [subscribe]]
   ["react" :as react]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.web.pages.feed :as feed]
   [motorsaif.string :refer [format]]
   [motorsaif.url :as url]
   [motorsaif.web.svg :as svg]
   [motorsaif.web.components :as c]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.web.pwa :as pwa]))

(defn header []
  [:header
   [:div.container
    [:div.logo svg/logo]
    [:div.links
     (when pwa/installable?
       [:button.btn.outline.install
        {:on-click #(rf/dispatch [:set-ui-state :install-pwa true])}
        [:i.fas.fa-download]
        "Install"])
     (if-let [user @(subscribe [:user])]
       [:div
        [:a.btn.primary
         {:href (routes/path-for :feed)}
         (:user/handle @(subscribe [:user]))]]

       [:a.btn.primary
        {:href (routes/path-for :sign-up)}
        (tr :page.home/get-started)])]]])

(defn footer []
  (let [trs (i18n/tr-scope [:footer])]
    [:footer
     [:div.links
      [:div.col
       [:h5 (tr :motorsaif "MotorSaif")]
       [:a
        {:href (routes/path-for :businesses)}
        (trs :for-biz "For Business")]
       [:a
        {:href (routes/path-for :feed)}
        (trs :browse)]]
      (when @(subscribe [:user])
        [:div.col
         [:h5
          (trs :account "Account")]
         [:a
          {:href (routes/path-for :profile)}
          (trs :profile "Profile")]
         [:a
          {:href (routes/path-for :messages)}
          (trs :messages "Messages")]
         [:a
          {:href (routes/path-for :new-request)}
          (trs :new-request "New Request")]]
        [:div.col
         [:h5
          (trs :account "Account")]
         [:a
          {:href (routes/path-for :login)}
          (trs :login "Login")]
         [:a
          {:href (routes/path-for :sign-up)}
          (trs :sign-up "Sign Up")]
         [:a
          {:href (routes/path-for :business-sign-up)}
          "Business Sign up"]])

      [:div.col
       [:h5
        (tr :footer/usage)]
       [:a
        {:href (routes/path-for :about)}
        (tr :footer/about)]
       [:a
        {:href (routes/path-for :terms)}
        (tr :footer/terms)]
       [:a
        {:href (routes/path-for :privacy)}
        (tr :footer/privacy-policy)]]

      [:div.col
       [:h5
        (tr :footer/partners)]
       [:a
        {:href "https://sayartii.com"}
        "Sayartii.com"]]]
     (let [{:keys [version git-hash]} @(subscribe [:build])]
       [:div.build
        (format "Ver %s | %s" version git-hash)])]))

(defn hero-section []
  (let [user? (some? @(rf/subscribe [:user]))]
    [:div#hero
     [:div.container
      [:div.first
       [:div.pretag "Redefining Auto Care"]
       [:h1
        "Auto Care "
        [:span.blue "Simplified"]]
       [:p.tagline "Get solutions from local businesses to your automotive requests for parts, repairs, and upgrades with real-time chat and multiple quotes."
        #_"Connect with verified local automotive businesses in real-time. Get quotes, chat, and book services - all in one place."]

       [:div.cta
        [:a.btn.primary
         {:href
          (routes/path-for
           (if user?
             :new-request
             :sign-up))}
         "New Request"]
        [:a.btn.outline
         {:href (routes/path-for :feed)}
         (tr :page.home/browse-requests "Browse Requests")]]]

      [:div.second
       [:div.image
        [:img {:src "/static/img/hero-img.webp"}]]]]]))

(defn how-section
  []
  (let [items
        [["Create a Request"
          "Describe your automotive need, add photos, and submit your request in minutes."]

         ["Receive Responses"
          "Local businesses respond with quotes, availability, and service details."]


         ["Chat and Compare"
          "Communicate directly with businesses to ask questions and compare offers."]


         ["Choose and Connect"
          "Select the best offer and finalize details for your automotive service."]]]
    [:section#how
     [:div.section-heading
      [:h2 "How MotorSaif Works"]
      [:p.subtitle "Get started in just a few easy steps"]]
     [:div.container
      (into [:div.steps]
            (map (fn [[title desc]]
                   [:div.step
                    [:div.num]
                    [:div
                     [:div.title title]
                     [:p.desc desc]]]) items))
      [:div.wrap
       [:img.frame {:src "/static/img/appscreen.webp"}]]]]))

(defn why-choose []
  (let [items [[[:i.fas.fa-clock]
                "Save Time"
                "Get multiple quotes without driving around"]

               [[:i.far.fa-shield]
                "Verified Businesses"
                "Work with trusted service providers"]

               [[:i.far.fa-messages]
                "Easy Communication"
                "Chat directly with businesses"]

               [[:i.far.fa-location-dot]
                "Local Services"
                "Find nearby automotive solutions"]]]
    [:section#why
     [:div.section-heading
      [:h2 "Why Choose MotorSaif"]
      [:p.subtitle "Benefits that make car care easier than ever"]]
     [:div.container
      (into [:div.items]
            (map (fn [[icon title desc]]
                   [:div.item
                    [:div.icon icon]
                    [:div.title title]
                    [:p.desc desc]])
                 items))]]))

(defn get-started []
  [:section#get-started
   [:div.container
    [:div.section-heading
     [:h2 "Ready to Simplify Your Auto Care?"]
     [:p.subtitle "Join for free and transform your automotive service experience. "]]
    [:div.cta
     [:a.btn.inverse
      {:href (routes/path-for :sign-up)}
      "Post your first request"]]]])

(defn time-saved []
  [:section#time
   [:div.container
    [:div.section-heading
     [:h2 "Time is Money, Save Both with MotorSaif"]
     [:p.subtitle "MotorSaif transforms the automotive service experience"]]
    [:div.wrap
     (let [trs (i18n/tr-scope [:page :home :with-motorsaif])]
       [:div.ms-flow
        [:div.heading
         [:i.far.fa-shield-check]
         [:h3 (trs :title)]]
        [:ul
         [:li
          [:i.far.fa-circle-check]
          [:div
           (trs :1 "In the comfort of your home or office...")
           [:div.sub (trs :1.sub "No need to drive around searching for services")]]]
         [:li
          [:i.far.fa-circle-check]
          [:div
           (trs :2 "Send request describing your part or car issue")
           [:div.sub (trs :2.5 "Simple form with photos and details")]]]
         [:li
          [:i.far.fa-circle-check]
          [:div
           (trs :3 "Receive instant messages to your request from local businesses")
           [:div.sub (trs :3.5 "Multiple responses within minutes")]]]
         [:li
          [:i.far.fa-circle-check]
          [:div
           (trs :4 "Decide from multiple quotations with just a single request")
           [:div.sub (trs :4.5 "Compare prices and service quality easily")]]]]])

     (let [trs (i18n/tr-scope [:page :home :without-motorsaif])]
       [:div.bad-flow
        [:div.heading
         [:i.far.fa-triangle-exclamation]
         [:h3 (trs :title "Without MotorSaif")]]
        [:ul
         [:li
          [:i.far.fa-circle-x]
          [:div
           (trs :1 "Drive around industrial areas in search of spare parts or a garage")
           [:div.sub (trs :1.5 "Wasting fuel and valuable time")]]]
         [:li
          [:i.far.fa-circle-x]
          [:div
           (trs :2 "Spend hours looking for a business to fulfill your request")
           [:div.sub (trs :2.5 "Multiple phone calls and physical visits")]]]
         [:li
          [:i.far.fa-circle-x]
          [:div
           (trs :3 "Your options are limited")
           [:div.sub (trs :3.5 "Difficult to compare prices and quality ")]]]
         [:li
          [:i.far.fa-circle-x]
          [:div
           (trs :4 "No guarantee you'll find what you're searching for")
           [:div.sub (trs :4.5 "Return home defeated")]]]]])]]])

(defn categories []
  (let [itms
        [[[:i.fas.fa-wrench]
          "Repairs"
          "Connect with garages that can fix any of your car issues, from engine problems to body work."
          "Post repair request →"]

         [[:i.fas.fa-sparkles]
          "Parts"
          "Source parts you need from scrap yards and part shops with competitive pricing and quality assurance."
          "Find parts →"]

         [[:i.fas.fa-gears]
          "Modifications"
          "Get performance upgrades, add entertainment systems, or customize your vehicle with expert installers."
          "Upgrade your car →"]]]
    [:section#categories
     [:div.container
      [:div.section-heading
       (when (= :dev @(rf/subscribe [:env]))
         {:on-click #(rf/dispatch [:admin/dev-login])})
       [:h2 "Automotive Services at Your Fingertips"]
       [:p.subtitle "Connect with the right businesses for all your automotive needs"]]

      (into [:div.categories]
            (map (fn [[icon title desc cta]]
                   [:div.category-card
                    [:div.icon icon]
                    [:div.title title]
                    [:p.desc desc]
                    [:a.cta
                     {:href (routes/path-for :sign-up)}
                     cta]])
                 itms))]]))

(defn motorsaif-concierge
  []
  [:section#concierge
   [:div.container
    [:div.section-heading
     (when (= :dev @(rf/subscribe [:env]))
       {:on-click #(rf/dispatch [:admin/dev-login])})
     [:h2 "MotorSaif Concierge"]
     [:p.subtitle "Next level service, we take care of everything"]]
    [:p.longp
     "With MotorSaif Concierge"
     [:span.highlight "you opt in to get personalized service"]
     " getting repairs or auto parts — without the hassle or uncertainty. Simply post your request, and our team will respond being your personal point of contact handling everything behind the scenes. We gather offers from trusted local providers, present you with the best options, and manage all communication and payments for a seamless, "
     [:span.highlight "secure experience."]]
    [:div.quote
     [:div.wrap
      [:p
       [:i.fas.fa-ditto]
       [:span
        "I was honestly surprised by how easy everything was. I just posted my request and the MotorSaif Concierge team handled the rest—finding the right garage, sorting out the details, and keeping me updated. My car was fixed without any stress on my end. I’d definitely use this service again. 10/10"]
       [:i.fas.fa-ditto]]
      [:div.author
       ;; [:i.far.fa-pen-fancy]
       [:i.far.fa-dash]
       " Future You"]]]]])


(defn root []
  [:div#home
   [header]
   [hero-section]
   [motorsaif-concierge]
   [time-saved]
   [categories]
   [how-section]
   [why-choose]
   [get-started]
   [footer]])
